import React, { useEffect, useRef, useState } from 'react';
import './Mission.css';

const Mission = () => {
  const textRef = useRef(null);
  const [isMouseInside, setIsMouseInside] = useState(false);
  
  useEffect(() => {
    const textElement = textRef.current; // Store the ref value in a variable
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            entry.target.classList.remove('visible');
          }
        });
      },
      {
        threshold: 0.1
      }
    );
  
    if (textElement) {
      observer.observe(textElement);
    }
  
    return () => {
      if (textElement) { // Use the stored variable in the cleanup
        observer.unobserve(textElement);
      }
    };
  }, []);
  

  const handleMouseEnter = () => {
    setIsMouseInside(true);
  };

  const handleMouseLeave = () => {
    setIsMouseInside(false);
  };

  return (
    <div 
      className="mission-container" 
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="gradient-background"></div>
      
      <div className="content-wrapper" ref={textRef}>
        <h1 className="mission-title">
          Our Mission
        </h1>
        
        <p className="mission-text">
        Quantiq empowers individuals to make confident financial 
        decisions with real-time, data-driven insights and personalized
         tools, making financial literacy and market understanding 
         accessible to everyone.
        </p>
      </div>

      <div 
        className="blob-container"
        style={{
          '--is-hovering': isMouseInside ? '1' : '1'
        }}
      >
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>
    </div>
  );
};

export default Mission;